import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCircleCheck = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "none",
	height: 18,
	viewBox: "0 0 18 18",
	width: 18,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m8.99984 17.3332c-4.60028-.0051-8.328284-3.7331-8.333336-8.33335v-.16666c.091609-4.57956 3.862156-8.226708 8.442226-8.165938s8.25257 3.806668 8.22257 8.387048c-.0299 4.5804-3.751 8.278-8.33146 8.2789zm-3.825-8.67501-1.175 1.175 3.33333 3.33331 6.66663-6.66665-1.175-1.18333-5.49163 5.49168z",
		fill: "#038a00"
	})
});
export { SvgCircleCheck as ReactComponent };
